export const RelationshipStatusOptions = [{ value: "Single", label: "Single" }, 
{ value: "In Relationship", label: "In Relationship" }, 
{ value: "Engaged", label: "Engaged" }, { value: "Married", label: "Married" }, 
{ value: "Divorced", label: "Divorced" }];